import { createContext } from "react";

/**
 * - `defaultSource`: first tab the user is allowed (when `source` is missing from URL)
 * - `activeSource`: resolved active tab (matches URL when valid, else first allowed tab);
 *   used by `useReceptionCenter` so the first request matches the selected tab.
 */
export const ReceptionCenterUrlContext = createContext(null);
